export default function LandingPage() {
	return (
		<div className="landing-page">
		<p><a href="/join">Join an existing centurion</a></p>
		<p><a href="/clock">Start a new centurion</a></p>
		</div>
	);
}
